import Link from "next/link";
import {
  IFtthOrchestrator,
  onboardingStarted,
} from "@nju/data-access-portal-orchestrator";
import { A, Panel, Text } from "@nju/ui";
import { FtthDashboardMainPage } from "../FtthDashboardMainPage";
import { ConvergenceBanner } from "./ConvergenceBanner";
import { FtthBanner } from "./FtthBanner";

interface IFtthProps {
  ftthOrchestrator: IFtthOrchestrator | undefined;
}

export function Ftth({ ftthOrchestrator }: IFtthProps) {
  if (
    !ftthOrchestrator ||
    (ftthOrchestrator && !onboardingStarted(ftthOrchestrator.state))
  ) {
    return (
      <div className="flex flex-col gap-4">
        <Panel
          iconName="shopping-bag"
          title="nie masz jeszcze usługi nju światłowód"
        >
          <Text size="l">
            Sprawdź naszą{" "}
            <Link
              href="https://www.njumobile.pl/oferta/swiatlowod"
              passHref={true}
              rel="noreferrer"
              target="_blank"
            >
              <A
                display="inline"
                size="inline"
                variant="neutral"
                withUnderline={true}
              >
                <Text size="l">ofertę</Text>
              </A>
            </Link>
            .
          </Text>
        </Panel>
        <div className="flex flex-col gap-4 from-tablet:flex-row">
          <FtthBanner />
          <ConvergenceBanner />
        </div>
      </div>
    );
  }

  return <FtthDashboardMainPage />;
}
